import { Element } from 'html-react-parser';
import { RichTextLink } from '@components/RichTextLink/RichTextLink';

const resolveLink = (
  link: Queries.kontent_item_rich_text_element_link,
  domNode: Element
): JSX.Element | null => <RichTextLink domNode={domNode} link={link} />;

export default resolveLink;
